<mds-text-field [inputType]="customParams().inputType" [appearance]="'outline'" [formCtrl]="formControl" />
